import { useEffect, useState } from "react";

export function useSchoolSubscriptionTypes(ApiClient) {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ApiClient?.subscriptions?.getSchoolSubscriptionTypes) return;

    let isMounted = true;

    const fetchSchoolSubscriptionTypes = async () => {
      try {
        setLoading(true);

        const result =
          await ApiClient.subscriptions.getSchoolSubscriptionTypes();

        if (isMounted) {
          setSubscriptions(result || []);
        }
      } catch (err) {
        console.error(err);
        if (isMounted) {
          setError(err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchSchoolSubscriptionTypes();

    return () => {
      isMounted = false;
    };
  }, [ApiClient]);

  return { subscriptions, loading, error };
}
